import { render, staticRenderFns } from "./AssigneeDisplayNameComponent.vue?vue&type=template&id=50a5b975&"
import script from "./AssigneeDisplayNameComponent.vue?vue&type=script&lang=js&"
export * from "./AssigneeDisplayNameComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports